export default "__VITE_ASSET__MSWsPN1x__";